import { auth } from "@super-resume-new/auth";
import { createMiddleware } from "@tanstack/react-start";

export const authMiddleware = createMiddleware().server(async ({ next, request }) => {
  let session = null;
  try {
    session = await auth.api.getSession({
      headers: request.headers,
    });
  } catch (error) {
    console.error("authMiddleware getSession error:", error);
  }
  return next({
    context: { session, headers: request.headers },
  });
});
